import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/employer")({
  beforeLoad: ({ location }) => {
    const normalized = location.pathname.replace(/\/+$/, "") || "/"
    if (normalized === "/employer") {
      throw redirect({ to: "/recruit" })
    }
  },
  component: () => <Outlet />,
})
